import axios from 'axios'
import Constants from '../constants'

export default {
  getTickets: (params, lang) => {
    const { viaLists, stations, places, token } = params
    return new Promise((resolve) => {
      axios.get('recommendTicket', { params: { id : Constants.API_ID, language: lang, viaLists: viaLists, stations: stations, places: places, token: token } })
        .then(payload => {
          resolve(payload.data.section)
        })
    })
  },
}